import { createRecord, getAllRecords } from '../db/indexeddb';
import { RECORD_TYPES, TYPE_LABELS, type RecordType } from '../lib/types';
import { showToast, escapeHtml } from './shared';

export async function renderFileThis(container: HTMLElement): Promise<void> {
  const records = await getAllRecords(false);
  const projects = records.filter((r) => ['project', 'active_priority'].includes(r.type));

  container.innerHTML = `
    <h2 style="font-size:19px; margin-bottom:2px;">File This</h2>
    <p style="color:var(--text-dim); font-size:13px;">Capture it now. Sort it out later. No AI required.</p>

    <label for="f-raw">Raw thought or description</label>
    <textarea id="f-raw" placeholder="Dump it here first — this becomes the description if you don't write one below."></textarea>

    <label for="f-title" class="required">Title</label>
    <input id="f-title" placeholder="Short, scannable title" />

    <label for="f-type" class="required">Type</label>
    <select id="f-type">
      ${RECORD_TYPES.map((t) => `<option value="${t}">${TYPE_LABELS[t]}</option>`).join('')}
    </select>

    <label for="f-parent">Parent project</label>
    <select id="f-parent">
      <option value="">— None —</option>
      ${projects.map((p) => `<option value="${p.id}">${escapeHtml(p.title)}</option>`).join('')}
    </select>

    <label for="f-next">Next action <span style="color:var(--text-faint); font-weight:400;">(optional)</span></label>
    <input id="f-next" placeholder="The very next physical action" />

    <label for="f-owner">Owner <span style="color:var(--text-faint); font-weight:400;">(optional)</span></label>
    <input id="f-owner" placeholder="Who owns this" value="William Blizzard" />

    <label for="f-deadline">Deadline <span style="color:var(--text-faint); font-weight:400;">(optional)</span></label>
    <input id="f-deadline" type="date" />

    <label for="f-notes">Notes <span style="color:var(--text-faint); font-weight:400;">(optional)</span></label>
    <textarea id="f-notes" placeholder="Anything else worth keeping"></textarea>

    <div class="form-actions">
      <button class="ghost" id="f-clear">Clear</button>
      <button class="primary" id="f-submit">File It</button>
    </div>
    <div class="field-hint" style="margin-top:10px; text-align:center;">Filed items land in the Inbox with default scores (5/10) — rank and route them anytime from the Vision Map.</div>
  `;

  const titleEl = container.querySelector('#f-title') as HTMLInputElement;
  const rawEl = container.querySelector('#f-raw') as HTMLTextAreaElement;
  const typeEl = container.querySelector('#f-type') as HTMLSelectElement;
  const parentEl = container.querySelector('#f-parent') as HTMLSelectElement;
  const nextEl = container.querySelector('#f-next') as HTMLInputElement;
  const ownerEl = container.querySelector('#f-owner') as HTMLInputElement;
  const deadlineEl = container.querySelector('#f-deadline') as HTMLInputElement;
  const notesEl = container.querySelector('#f-notes') as HTMLTextAreaElement;

  container.querySelector('#f-clear')?.addEventListener('click', () => {
    titleEl.value = ''; rawEl.value = ''; nextEl.value = ''; deadlineEl.value = ''; notesEl.value = '';
    typeEl.value = 'idea'; parentEl.value = '';
  });

  container.querySelector('#f-submit')?.addEventListener('click', async () => {
    const title = titleEl.value.trim() || rawEl.value.trim().slice(0, 80);
    if (!title) { showToast('Give it a title (or a raw thought to derive one from)', 'error'); return; }

    await createRecord({
      title,
      description: rawEl.value.trim(),
      type: typeEl.value as RecordType,
      parent_id: parentEl.value || null,
      next_action: nextEl.value.trim(),
      owner: ownerEl.value.trim(),
      deadline: deadlineEl.value || null,
      notes: notesEl.value.trim(),
      raw_capture: rawEl.value.trim(),
      status: 'inbox',
    });

    showToast('Filed to the Inbox');
    titleEl.value = ''; rawEl.value = ''; nextEl.value = ''; deadlineEl.value = ''; notesEl.value = '';
    typeEl.value = 'idea'; parentEl.value = '';
    titleEl.focus();
  });
}
